
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformer01 as ObiTransformer01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-transformer-01.js';
 
 
 

 
 export const ObiTransformer01 = createComponent({
   react: React,
   tagName: 'obi-transformer-01',
   elementClass: ObiTransformer01Element,
   events: {
     
   }
  });
 
 